/* © CNES */
import { Control } from 'ol/control';
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { ConfigContext } from '../../../../context/ConfigContext';
import MapContext from '../../MapContext';
import './DrawShapeControl.scss';

/**
 * Draw Shape Control.
 * @param isDrawModeOn Boolean if draw shape mode is active.
 * @param setDrawMode Function to toggle the draw shape mode.
 * @returns null
 */
const DrawShapeControl = ({
  isDrawModeOn,
  setDrawMode,
}: {
  isDrawModeOn: boolean;
  setDrawMode: Dispatch<SetStateAction<boolean>>;
}) => {
  const { map } = useContext(MapContext);
  const context = useContext(ConfigContext);
  let localIsDrawModeOn = useRef(isDrawModeOn);

  const toggleInteraction = useCallback(() => {
    localIsDrawModeOn.current = !isDrawModeOn;
    setDrawMode(localIsDrawModeOn.current);
  }, [isDrawModeOn, setDrawMode]);

  /**
   * Add Options to draw shape on map.
   */
  useEffect(() => {
    if (!map) return;

    const button = document.createElement('button');

    button.innerHTML = '<i class = "pi pi-stop" style="font-size:0.7rem">';
    button.id = 'draw-shape-button';
    button.title = 'Rectangular AOI';
    const element = document.createElement('div');
    element.id = 'draw-shape';
    element.className = 'draw-shape-halfscreen ol-unselectable ol-control';
    if (context.isLeftSidePanelShown) {
      element.className = 'draw-shape-fullscreen ol-unselectable ol-control';
    }
    element.appendChild(button);
    button.addEventListener('click', toggleInteraction, false);
    let customControl = new Control({ element });
    map.addControl(customControl);

    return () => {
      map.removeControl(customControl);
    };
  }, [map, isDrawModeOn, toggleInteraction, context]);

  return null;
};
export default DrawShapeControl;
